export const appConfiguration = {
  fuelingServiceUri: import.meta.env.VITE_FUELING_SERVICE_URI,
  locationId: import.meta.env.VITE_LOCATION_ID,
  pumpNumber: import.meta.env.VITE_PUMP_NUMBER,
};
